module.exports = "js/webpack/df803345f8879faa61c4f4d0c66224e1.svg";